import React from "react";
import { Modal } from "flowbite-react";
import { useModal } from "../hooks/UseModalContext";

interface ShModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  title?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl';
  children?: React.ReactNode;
}

const ShModal: React.FC<ShModalProps> = ({ 
  isOpen, 
  onClose, 
  title, 
  size = '4xl', 
  children 
}) => {
  const modalContext = useModal();

  // Se vengono passate props dirette, usa quelle; altrimenti usa il context
  const modalIsOpen = isOpen !== undefined ? isOpen : modalContext.isOpen;
  const modalOnClose = onClose || modalContext.closeModal;
  const modalContent = children || modalContext.modalContent;

  if (!modalIsOpen) return null;

  return (
    <Modal
      show={modalIsOpen}
      position={"top-center"}
      onClose={modalOnClose}
      className="relative pt-8 px-[38.5px]"
      size={size}
      dismissible
    >
      {title && (
        <Modal.Header>
          <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
        </Modal.Header>
      )}
      <Modal.Body>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          {modalContent}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShModal;